import { render, staticRenderFns } from "./photo.vue?vue&type=template&id=18d5566d"
import script from "./photo.vue?vue&type=script&lang=js"
export * from "./photo.vue?vue&type=script&lang=js"
import style0 from "./photo.vue?vue&type=style&index=0&id=18d5566d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports